@if (isRangeMoment()) {
  <!-- Periode-moment: geen vast tijdstip, dus geen activaties om te duiden. -->
  <p class="hd-cycle-keynote-sections__range-info">{{ rangeInfo() }}</p>
} @else if (visible()) {
  <!-- Niet zelf center thema's: ongedefinieerde natal-centers die door de cycle
       definitie krijgen, als cheat-sheet-blokjes (klik = center-info, poort-pil = poortinfo). -->
  @if (conditionedCenters().length > 0) {
    <section class="hd-cycle-keynote-sections__centers">
      <h4 class="hd-cycle-keynote-sections__subsection-title">{{ centersTitle() }}</h4>
      @for (item of conditionedCenters(); track item.center) {
        <hd-cycle-conditioned-center-block
          [center]="item.center"
          [label]="item.label"
          [text]="item.text"
          [causes]="item.causes"
          clickable
          (centerInfoRequested)="centerInfoRequested.emit($event)"
          (gateInfoRequested)="gateInfoRequested.emit($event)"
        />
      }
    </section>
  }

  <!-- Cyclus details: amber subsectie-titel met rechts de ene toggle
       tussen de keynote-secties en de planetengrid. -->
  <div class="hd-cycle-keynote-sections__view-toggle-bar">
    <h4 class="hd-cycle-keynote-sections__subsection-title hd-cycle-keynote-sections__subsection-title--inline">{{ detailsTitle() }}</h4>
    <button
      type="button"
      class="hd-cycle-keynote-sections__view-toggle"
      [attr.aria-pressed]="viewMode() === 'grid'"
      [attr.aria-label]="viewToggleTooltip()"
      [title]="viewToggleTooltip()"
      (click)="toggleViewMode()"
    >
      <i class="fas fa-{{ viewMode() === 'sections' ? 'table-list' : 'layer-group' }}" aria-hidden="true"></i>
    </button>
  </div>

  @if (viewMode() === 'grid') {
    <hd-cycle-planet-grid
      [preset]="preset()"
      [breakdown]="breakdown()"
      (gateInfoRequested)="gateInfoRequested.emit($event)"
    />
  } @else {
    @for (section of sections(); track section.key) {
      <section class="hd-cycle-keynote-sections__section"
               [class.hd-cycle-keynote-sections__section--muted]="section.muted">
        <!-- Cheat-sheet-header: kaartkleur + icoon, titel + brings op 2 regels, chevron rechts. -->
        <hd-cycle-section-header
          [color]="section.color"
          [faIcon]="section.faIcon"
          [title]="section.title"
          [bringsLabel]="section.bringsLabel"
          [brings]="section.brings"
          [expanded]="isExpanded(section.key)"
          (toggle)="toggleSection(section.key)"
        />

        @if (isExpanded(section.key)) {
          <ul class="hd-cycle-keynote-sections__bullets">
            @for (bullet of section.bullets; track $index) {
              <li [innerHTML]="bullet"></li>
            }
          </ul>
        }

        @for (item of section.channels; track item.key) {
          <div class="hd-cycle-keynote-sections__item">
            <hd-channel-list-item
              [channelKey]="item.channel.channelKey"
              [cycleGates]="item.channel.gates"
              [keynoteKey]="section.channelKeynoteKey"
              [accent]="section.channelAccent"
              expandable
              [expanded]="items.isExpanded(item.key)"
              (expandToggled)="items.toggle(item.key)"
              (gateInfoRequested)="gateInfoRequested.emit($event)"
              (channelInfoRequested)="channelInfoRequested.emit($event)"
            />
            <!-- I Tjing-kaarten van de cycle-poorten: default dicht, pas gebouwd bij uitklappen. -->
            <hd-cycle-cards [slots]="item.cards" [visible]="items.isExpanded(item.key)" />
          </div>
        }

        @for (item of section.hangingGates; track item.key) {
          <div class="hd-cycle-keynote-sections__item">
            <!-- Zelfde blokje als de kanaal-items, alleen zonder kanaal — enkel de poortinfo. -->
            <hd-cycle-hanging-gate-block
              [hanging]="item.hanging"
              [color]="section.color"
              [faIcon]="section.faIcon"
              expandable
              [expanded]="items.isExpanded(item.key)"
              (expandToggled)="items.toggle(item.key)"
              (gateInfoRequested)="gateInfoRequested.emit($event)"
            />
            <hd-cycle-cards [slots]="item.cards" [visible]="items.isExpanded(item.key)" />
          </div>
        }
      </section>
    }
  }
}
